import React from 'react'
import { DayType } from '../constants/DayType'

const DayBadge = ({ dayType }: { dayType: DayType }) => {
  return (
    <div className="tw-px-[2px] tw-py-1">
      <p className="tw-text-left tw-text-[10px] tw-text-[#1F2937]">
        {dayType === DayType.NoContract ? '-' : (DayType[dayType] ?? '')}
      </p>
    </div>
  )
}

export default DayBadge
